(function() {
    'use strict';
a3_cabin_reports.factory('CrewAssessmentMemberFactory', CrewAssessmentMemberFactory)
    
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewAssessmentMemberFactory
    * @description 
    *   Initializes new Crew Assessment Members
    * @ngInject
    */           
function CrewAssessmentMemberFactory() {

        /**
        * Initialize the Crew Assessment Member
        * @memberof CrewAssessmentMemberFactory
        */
		function CrewAssessmentMember() {
			this.aimsId = null;
			this.id = null;
			this.name = null;
			this.IsCompleted = false;
			this.IsValid = true;
			this.IsOverride = false;
			this.IsManual = false;
			this.IsExist = false;
            this.Review = null;
			this.assessmentItems = [];
            this.IsOutdated = false;
            this.EndPeriod = null;
		}

		var service = 
		{
			newMember : newMember
		}

        /**
         * Create New Crew Assessment Member
         * @memberof CrewAssessmentMemberFactory
         * @returns {object} CrewAssessmentMember 
         */
		function newMember() {
			return new CrewAssessmentMember();
		}

	return service;
}
    
})();